var samsung_BN59_00603A = {
    name: "BN59_00603A",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,223,218,170,136],
        },
        {
            function: "KEY_CYCLEWINDOWS",
            name: "KEY_CYCLEWINDOWS",
            icon: "KEY_CYCLEWINDOWS",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,191,234,170,136],
        },
        {
            // function: "KEY_TV",
            function: "KEY_SOURCE",
            name: "KEY_SOURCE",
            icon: "KEY_SOURCE",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,181,87,126,136],
        },
        {
            function: "KEY_DVD",
            name: "KEY_DVD",
            icon: "KEY_DVD",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,213,86,254,136],
        },
        {
            function: "STB",
            name: "STB",
            icon: "STB",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,170,171,254,136],
        },
        {
            function: "Cable",
            name: "Cable",
            icon: "Cable",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,173,87,190,136],
        },
        {
            function: "KEY_1",
            name: "KEY_1",
            icon: "KEY_1",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,239,214,170,136],
        },
        {
            function: "KEY_2",
            name: "KEY_2",
            icon: "KEY_2",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,183,246,170,136],
        },
        {
            function: "KEY_3",
            name: "KEY_3",
            icon: "KEY_3",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,215,238,170,136],
        },
        {
            function: "KEY_4",
            name: "KEY_4",
            icon: "KEY_4",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,247,213,170,136],
        },
        {
            function: "KEY_5",
            name: "KEY_5",
            icon: "KEY_5",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,187,245,170,136],
        },
        {
            function: "KEY_6",
            name: "KEY_6",
            icon: "KEY_6",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,219,237,170,136],
        },
        {
            function: "KEY_7",
            name: "KEY_7",
            icon: "KEY_7",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,235,235,170,136],
        },
        {
            function: "KEY_8",
            name: "KEY_8",
            icon: "KEY_8",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,181,251,170,136],
        },
        {
            function: "KEY_9",
            name: "KEY_9",
            icon: "KEY_9",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,213,247,170,136],
        },
        {
            function: "Dashes",
            name: "Dashes",
            icon: "Dashes",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,175,125,90,136],
        },
        {
            function: "KEY_0",
            name: "KEY_0",
            icon: "KEY_0",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,189,245,106,136],
        },
        {
            function: "Pre-CH",
            name: "Pre-CH",
            icon: "Pre-CH",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,174,253,106,136],
        },
        {
            function: "TV/DTV",
            name: "TV/DTV",
            icon: "TV/DTV",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,175,189,86,136],
        },
        {
            function: "ChList",
            name: "ChList",
            icon: "ChList",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,173,175,110,136],
        },
        {
            function: "D.Menu",
            name: "D.Menu",
            icon: "D.Menu",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,213,235,213,136],
        },
        {
            function: "KEY_RECORD",
            name: "KEY_RECORD",
            icon: "KEY_RECORD",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,187,186,214,136],
        },
        {
            function: "KEY_REWIND",
            name: "KEY_REWIND",
            icon: "KEY_REWIND",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,183,187,86,136],
        },
        {
            function: "KEY_STOP",
            name: "KEY_STOP",
            icon: "KEY_STOP",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,215,183,86,136],
        },
        {
            function: "KEY_PLAYPAUSE",
            name: "KEY_PLAYPAUSE",
            icon: "KEY_PLAYPAUSE",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,171,223,86,136],
        },
        {
            function: "KEY_FORWARD",
            name: "KEY_FORWARD",
            icon: "KEY_FORWARD",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,247,106,214,136],
        },
        {
            function: "KEY_VOLUMEUP",
            name: "KEY_VOLUMEUP",
            icon: "KEY_VOLUMEUP",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,171,254,170,136],
        },
        {
            function: "KEY_VOLUMEDOWN",
            name: "KEY_VOLUMEDOWN",
            icon: "KEY_VOLUMEDOWN",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,173,253,170,136],
        },
        {
            function: "KEY_CHANNELUP",
            name: "KEY_CHANNELUP",
            icon: "KEY_CHANNELUP",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,221,237,106,136],
        },
        {
            function: "KEY_CHANNELDOWN",
            name: "KEY_CHANNELDOWN",
            icon: "KEY_CHANNELDOWN",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,251,213,106,136],
        },
        {
            function: "KEY_MUTE",
            name: "KEY_MUTE",
            icon: "KEY_MUTE",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,170,255,170,136],
        },
        {
            function: "KEY_MENU",
            name: "KEY_MENU",
            icon: "KEY_MENU",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,218,246,234,136],
        },
        {
            function: "KEY_EXIT",
            name: "KEY_EXIT",
            icon: "KEY_EXIT",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,181,189,218,136],
        },
        {
            function: "KEY_UP",
            name: "KEY_UP",
            icon: "KEY_UP",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,253,106,174,136],
        },
        {
            function: "KEY_DOWN",
            name: "KEY_DOWN",
            icon: "KEY_DOWN",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,190,186,174,136],
        },
        {
            function: "KEY_LEFT",
            name: "KEY_LEFT",
            icon: "KEY_LEFT",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,183,93,174,136],
        },
        {
            function: "KEY_RIGHT",
            name: "KEY_RIGHT",
            icon: "KEY_RIGHT",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,222,182,174,136],
        },
        {
            function: "Enter/OK",
            name: "Enter/OK",
            icon: "Enter/OK",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,246,181,110,136],
        },
        {
            function: "KEY_ENTER",
            name: "KEY_ENTER",
            icon: "KEY_ENTER",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,245,181,118,136],
        },
        {
            function: "KEY_INFO",
            name: "KEY_INFO",
            icon: "KEY_INFO",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,170,239,214,136],
        },
        {
            function: "AnyNet",
            name: "AnyNet",
            icon: "AnyNet",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,171,119,181,136],
        },
        {
            function: "KEY_RED",
            name: "KEY_RED",
            icon: "KEY_RED",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,235,90,238,136],
        },
        {
            function: "KEY_GREEN",
            name: "KEY_GREEN",
            icon: "KEY_GREEN",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,237,235,106,136],
        },
        {
            function: "KEY_YELLOW",
            name: "KEY_YELLOW",
            icon: "KEY_YELLOW",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,182,251,106,136],
        },
        {
            function: "KEY_BLUE",
            name: "KEY_BLUE",
            icon: "KEY_BLUE",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,214,247,106,136],
        },
        {
            function: "Text/Mix",
            name: "Text/Mix",
            icon: "Text/Mix",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,235,117,218,136],
        },
        {
            function: "P.Size",
            name: "P.Size",
            icon: "P.Size",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,213,93,250,136],
        },
        {
            function: "P.Mode",
            name: "P.Mode",
            icon: "P.Mode",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,246,234,218,136],
        },
        {
            function: "PIP",
            name: "PIP",
            icon: "PIP",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,253,213,90,136],
        },
        {
            function: "Dual",
            name: "Dual",
            icon: "Dual",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,255,170,170,136],
        },
        {
            function: "Still",
            name: "Still",
            icon: "Still",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,223,109,86,136],
        },
        {
            function: "KEY_SUBTITLE",
            name: "KEY_SUBTITLE",
            icon: "KEY_SUBTITLE",
            command: [68,0,4,83,2,253,1,83,2,88,6,141,17,58,17,77,2,33,184,42,253,95,183,123,90,136],
        },
    ]
}
export default samsung_BN59_00603A